<template>
  <div>
    <GmapMarker
      v-for="(place, index) in places"
      :key="index"
      :position="{ lat: place.location.latitude, lng: place.location.longitude }"
      :clickable="true"
      :draggable="false"
      :icon="icon(place)"
      :zIndex="1"
      @click="onMarkerSelected(place)" >
    </GmapMarker>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'

export default {
  created () {
    this.places = this.$store.getters['places/getFilteredPlaces']
  },
  data () {
    return {
      places: []
    }
  },
  methods: {
    onMarkerSelected: function (place) {
      this.$store.dispatch('map/openPlace', { place: place, full: false })
    },
    icon: function (place) {
      if (this.google) {
        let size = new this.google.maps.Size(36, 36)
        if (this.selectedPlace && place.id === this.selectedPlace.id) {
          size = new this.google.maps.Size(62, 62)
        }
        return {
          url: this.iconPath(place),
          scaledSize: size
        }
      }
    },
    iconPath(place) {
      if (place.mapIcon.length > 0) {
        return place.mapIcon
      } else {
        return require('@/assets/images/icon-map.png')
      }
    }
  },
  computed: {
    ...mapGetters({
      filter: 'user/getFilter',
      genreIds: 'genres/getParentGenreIds',
      selectedPlace: 'map/getSelectedPlace'
    }),
    google: gmapApi
  },
  watch: {
    filter: {
      handler: function () {
        this.places = this.$store.getters['places/getFilteredPlaces']
      },
      deep: true
    }
  }
}
</script>
